/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService
 */

export const AiChatbotRoutingTypename = 'com.hubspot.cv.assignments.core.routing.AiChatbotRouting';
export const BotRoutingTypename = 'com.hubspot.cv.assignments.core.routing.BotRouting';
export const CustomerAgentComplexRoutingTypename = 'com.hubspot.cv.assignments.core.routing.CustomerAgentComplexRouting';
export const CustomerAgentRoutingTypename = 'com.hubspot.cv.assignments.core.routing.CustomerAgentRouting';
export const InboxUsersRoutingTypename = 'com.hubspot.cv.assignments.core.routing.InboxUsersRouting';
export const OwnerRoutingTypename = 'com.hubspot.cv.assignments.core.routing.OwnerRouting';
export const QuoteOwnerRoutingTypename = 'com.hubspot.cv.assignments.core.routing.QuoteOwnerRouting';
export const SkillBasedRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SkillBasedRouting';
export const SkillRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SkillRouting';
export const SpecifiedHoursRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SpecifiedHoursRouting';
export const TeamsOnlyRoutingTypename = 'com.hubspot.cv.assignments.core.routing.TeamsOnlyRouting';
export const UnassignedRoutingTypename = 'com.hubspot.cv.assignments.core.routing.UnassignedRouting';
export const UsersAndTeamsRoutingTypename = 'com.hubspot.cv.assignments.core.routing.UsersAndTeamsRouting';
export const WaitlistRoutingTypename = 'com.hubspot.cv.assignments.core.routing.WaitlistRouting';
export const WorkflowRoutingTypename = 'com.hubspot.cv.assignments.core.routing.WorkflowRouting';
export const isMaintenanceModeEnabledRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'isMaintenanceModeEnabled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABWDoMUAiQ5eD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAgentRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'createAgent',
  auth: 'app',
  fingerprint: 'NDTosTI9ayeU3a3qyujVnD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentProfileRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'updateAgentProfile',
  auth: 'app',
  fingerprint: '-o0ABTsT0kh6NKXuXc_7rT4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentProfileByUserIdRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAgentProfileByUserId',
  auth: 'app',
  fingerprint: 'ENQCoPd7p0N6NKXuXc_7rT4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentByUserIdRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAgentByUserId',
  auth: 'app',
  fingerprint: 'ENQCoPd7p0PuvaW8eY6IGj4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAiAgentOrThrowIfMultipleRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentOrThrowIfMultiple',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABpqWz6IGuGRD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAiAgentsForPortalRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentsForPortal',
  auth: 'app',
  fingerprint: 'LP3IbM57wEiFOmwC8DMSdz4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAiAgentProfilesForPortalRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentProfilesForPortal',
  auth: 'app',
  fingerprint: '1RszLRddEc0OsLnyNLiBfT4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHydratedAiAgentDataForPortalRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getHydratedAiAgentDataForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAB-QLzqPqLhAD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHydratedAiAgentDataForPortalV2Rpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getHydratedAiAgentDataForPortalV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABqYL73YzqSnT4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteAgentRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'deleteAgent',
  auth: 'app',
  fingerprint: 'ZWFHm1kMw2mOQ99dyMYnND4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const restoreAgentRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'restoreAgent',
  auth: 'app',
  fingerprint: 'YjE9mdW-BFqOQ99dyMYnND4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const migratePortalToNewHandoffRpc = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'migratePortalToNewHandoff',
  auth: 'app',
  fingerprint: '8t-59LHST7yOQ99dyMYnND4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};